import _ from 'lodash';

const processStrategy = (report) => {
  const relations = {};
  const omit = [];
  return { ..._.omit(report, omit), ..._.pickBy(relations, _.identity) };
};

export default {
  key: 'report',
  definition: {},
  processStrategy,
};
